import EmberSimpleAuthSessionService from 'ember-simple-auth/services/session';


interface ISessionServiceData {
  authenticated: {
    id: string;
    token: string;
    type: 'authenticator:jwt';
    userId: string;
    expiresOn: string;
  };
}

export default class SessionService extends EmberSimpleAuthSessionService<ISessionServiceData> {
}

declare module '@ember/service' {
  interface Registry {
    'session': SessionService;
  }
}
